import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const useTitle = (title: string) => {
  const { t } = useTranslation()

  const baseTitle = t('procurement')
  useEffect(() => {
    if (title) {
      document.title = `${baseTitle} - ${title}`
    }

    return (): void => {
      document.title = baseTitle
    }
  }, [baseTitle, title])
}
